import type {
  ProfileVisibility2TypeNames,
  ProfileVisibilityOptions,
} from './types';

export const getOptionFromProfileVisibilityId = (
  profileVisibilityOptions: ProfileVisibilityOptions,
  id: string,
) => profileVisibilityOptions.find((option) => option.id === id);

export const isPublicOrStandardTypeName = (
  typeName?: ProfileVisibility2TypeNames,
) =>
  typeName === 'PublicVisibilityOption' ||
  typeName === 'StandardVisibilityOption';
